/**
 * True only while the very first fetch is in flight (loading with no data
 * yet). Full-page spinners must be limited to this initial load: once the
 * page has data, the header/search bar must stay mounted during refetches —
 * unmounting them steals focus from the search input when a debounced fetch
 * fires mid-typing.
 */
export function useIsInitialLoad(loading: boolean, items: unknown[]): boolean {
  return loading && items.length === 0;
}
